/*
 * "Other Products For Your {vehicle}" rules (blocks/product_other-products.liquid): which other products fit the
 * vehicle on this page, what each card costs and where its CUSTOMIZE button goes. No DOM, so the rules can be
 * checked on their own. Loaded `defer` after the core and seatfit-vehicle-picker-lists.js (CUSTOMIZE is the
 * drawer's GO link, so both keep the ad tracking params) and before seatfit-other-products.js.
 * Prices as on the reference cards: a car cover shows the first colour of the first row of that year (Camry 2020:
 * $229.95), floor mats the cheapest Front or Full Set of that year (any set when it has neither). Seat cover data has no
 * prices, so Liquid prints the seat product's Front Seats price on that card instead.
 */
(function () {
  'use strict';
  if (window.SeatFitOtherProducts) return;

  var ORDER = ['seat', 'cover', 'mat']; // card order: seat covers first, as on the reference pages
  var MAIN_SETS = ['front', 'full-set'];

  // The product's data has the car for that year, with at least one row to sell.
  function fits(ctx) {
    return !!(ctx && ctx.status === 'ok' && ctx.make && ctx.model && ctx.rows && ctx.rows.length);
  }

  // {tier, price, compareAt} of a card; null for seat covers (priced by Liquid) or a row without a known tier.
  function priceOf(ctx) {
    var SF = window.SeatFit;
    var kind = SF.kindOf(ctx);
    var rows = ctx.rows || [];
    if (kind === 'cover') {
      var row = rows[0];
      var colour = row && row.c ? Object.keys(row.c)[0] : null;
      return colour ? SF.tierPrice(ctx, row.c[colour]) : null;
    }
    if (kind !== 'mat') return null;
    // The reference cards show the cheapest Front/Full Set of the year (F-150 2020: $159.95, the Regular Cab Front
    // set, below the $199.95 Full Set); a Third Row or Complete Set price would misprice the car's main set.
    var main = rows.filter(function (r) {
      return (r.st || []).some(function (p) {
        return p && SF.isOptionStep(ctx, p[0]) && MAIN_SETS.indexOf(SF.slugify(p[1])) >= 0;
      });
    });
    return SF.tiersFor(ctx, main.length ? main : rows)[0] || null;
  }

  // The cart drawer cards say "From": the cheapest price this vehicle can buy. Car covers: any row and colour of the
  // year (Camry 2020: $189.95, where the buy-box card shows the first colour, $229.95). Floor mats: the main
  // Front/Full sets, as on the buy-box card. Seats: null (Liquid prints the seat card's price).
  function fromPriceOf(ctx) {
    var SF = window.SeatFit;
    var kind = SF.kindOf(ctx);
    if (kind === 'cover') return SF.tiersFor(ctx)[0] || null;
    return kind === 'mat' ? priceOf(ctx) : null;
  }

  // "2020 Toyota Camry", named the way this page's product data names it; if that data lacks the car, the way the
  // first other product that has it does.
  function vehicleLine(pageKind, ctxs) {
    var own = ctxs[pageKind];
    var ctx = fits(own) ? own : ORDER.map(function (k) { return ctxs[k]; }).filter(fits)[0];
    return ctx ? window.SeatFit.vehicleLabel(ctx) : '';
  }

  // What the block draws: {show, line, cards: [{kind, show, price, compareAt, href}]}, cards in ORDER without the
  // page's own product. ctxs = SeatFit.resolve() of the same ?year&make&model for every kind. CUSTOMIZE carries the
  // slugs of the target product's own data, so its page finds the car.
  function view(pageKind, ctxs, currentHref) {
    var SF = window.SeatFit;
    var goUrl = window.SeatFitPickerLists.goUrl;
    var cards = ORDER.filter(function (k) { return k !== pageKind; }).map(function (k) {
      var ctx = ctxs[k];
      if (!fits(ctx)) return { kind: k, show: false };
      var p = priceOf(ctx) || {};
      var price = typeof p.price === 'number' ? p.price : null;
      return {
        kind: k, show: true, price: price,
        compareAt: price != null && p.compareAt > price ? p.compareAt : null,
        href: goUrl(SF.kindConfig(k).productUrl, { year: ctx.year, make: ctx.make.s, model: ctx.model.s }, currentHref)
      };
    });
    var show = cards.some(function (c) { return c.show; });
    return { show: show, line: show ? vehicleLine(pageKind, ctxs) : '', cards: cards };
  }

  // A price in the shop currency written with the shop's money format ("${{amount}}", "{{amount_with_comma_separator}}
  // €" ...); tags some formats carry are dropped because the text goes in with textContent.
  var SEPARATORS = [[/period_and_space/, [' ', '.']], [/comma_separator/, ['.', ',']], [/apostrophe/, ["'", '.']],
    [/space_separator/, [' ', ',']]];
  function money(amount, format) {
    if (typeof amount !== 'number' || !isFinite(amount)) return '';
    var fmt = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var style = m ? m[1] : 'amount';
    var seps = [',', '.'];
    SEPARATORS.some(function (s) { return s[0].test(style) ? (seps = s[1]) : false; });
    var parts = amount.toFixed(/no_decimals/.test(style) ? 0 : 2).split('.');
    var text = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, seps[0]) + (parts[1] ? seps[1] + parts[1] : '');
    return m ? fmt.replace(m[0], text) : text;
  }

  window.SeatFitOtherProducts = { ORDER: ORDER, fits: fits, priceOf: priceOf, fromPriceOf: fromPriceOf,
    vehicleLine: vehicleLine, view: view, money: money };
})();
